import React,{useState, useEffect, useRef} from 'react'
import moment from "moment";
import axios from '../../../plugins/axios'

import SvgTrendWave from './svgTrendWave';

const TrendWave = ({ deviceInfo, startTime, endTime, selectTime, leadType, patientHistories }) => {    
    const [trendData, setTrendData] = useState()
    const [boxInfo, setBoxInfo] = useState();
    const [patientDischargeMarker, setPatientDischargeMarker] = useState(null)

    const getWaveData = async () => {
        try{            
            const waveRes = await axios.get(`/trend/waveforms?serialNo=${deviceInfo?.serial}&type=${leadType}&startTime=${startTime}&endTime=${endTime}`)
            const Wave = setTrendWaveList(waveRes.data.waveformData.waveforms,startTime,endTime)
            const ResultWave = setSplitData(Wave, 30);                     

            setTrendData(ResultWave)
        }
        catch(err){
            console.warn('getWaveData Error : ', err);
        }
    }

    //moment로 보내서 moment.utc로 묶어서 09:00을 +시켜버리는 작업을 하였음.
    const setTrendWaveList = (data, waveStartTime, waveEndTime) => {
        // 시작 시간과 끝 시간을 moment로 변환
        const start = moment.utc(waveStartTime).startOf("second");
        const end = moment.utc(waveEndTime).startOf("second"); 

        // 시작 시간부터 끝 시간까지 초 단위로 빈 데이터 생성
        const allSeconds = [];
        let current = start.clone();
        while (current < end) {
            allSeconds.push(current.utc().format());
            current.add(1, "second");
        }        

        // 실제 데이터를 Timestamp : value 형태로 변환        
        const groupedBySecond = data.reduce((acc, item) => {
            const secondKey = moment.utc(item.timestamp).startOf("second").format();  
            acc[secondKey] = item.samples || [];
            return acc;
        }, {});        

        let completeResult = [];

        // 초 단위 데이터를 모두 포함하도록 병합
        completeResult = allSeconds.map((second) => ({
            createdAt: second,
            wave: groupedBySecond[second] || [], // 데이터가 없으면 빈 배열
        }));

        return completeResult;
    };

    //데이터 30개씩 나누기
    const setSplitData = (data, batchSize) => {
        if(!data) return [];
        const result = [];
        let batch = [];
    
        for (let i = 0; i < data.length; i++) {
            batch.push(data[i]);
            if (batch.length === batchSize || i === data.length - 1) {
                result.push(batch);
                batch = [];
            }
        }
    
        return result;
    }

    const getPatientDischargeMarker = (waveStartTime, waveEndTime) => {
        if (!patientHistories || !Array.isArray(patientHistories)) {
            setPatientDischargeMarker([]);
            return;
        }

        // 1. waveStartDate ~ waveEndTime 범위의 ADDMITTIED, UNASSIGNED 데이터만 추출
        const histories_startTime = waveStartTime;
        const histories_endTime = waveEndTime;        

        const filtered = patientHistories            
            .filter(h => {
                const t = moment(h.createdAt).add(9,'hours');                
                return t.isValid() && t.isSameOrAfter(histories_startTime) && t.isSameOrBefore(histories_endTime);
            });

        // 2. createdAt 포맷 변환 ("2025-08-26T19:52:37Z" 형태)
        const markers = filtered.map(h => ({
            ...h,
            formattedTime: moment(h.createdAt).format("YYYY-MM-DDTHH:mm:ss[Z]")
        }));

        // 3. 마커 세팅
        setPatientDischargeMarker(markers);
    };

    // Wave 박스 정보 설정 (가로 세로 크기 등등)
    const setWaveBoxInfo = () => {
        const containerRect = 3205; //가로 A4 용지 사이즈에서 Border 길이만큼 뺀거 (인쇄 할 때 짤림)        
        let width = (containerRect - 4) / 2;
        let height = 116; 

        setBoxInfo({            
            width : width,
            height : height,            
            strokeWidth: 1.5,
            strokeColor: "#000",            
        });
    }

    useEffect(() => {        
        getPatientDischargeMarker(startTime, endTime);
        getWaveData(); 
    }, [deviceInfo]);

    useEffect(() => {
        setWaveBoxInfo();
    }, [trendData]);

    const selectBoxStyle = "border-[4px] border-[#000] border-dotted bg-[#fff] rounded-[8px]]";
    const defaultBoxStyle = "border-[1px] border-[#AEAEAE] border-box ";
    const timeFontStyle = 'text-black text-center font-pretendard text-[32px] font-light leading-[40px]';

    return (
        <div className='w-full flex flex-col'>
            <div className='flex w-full items-center justify-start'>
                <span className={timeFontStyle}>{startTime ?  moment.utc(startTime).format('YYYY-MM-DD HH:mm:ss') : '---'}</span>
            </div>
            <div className='relative flex flex-wrap justify-center flex-1 w-full h-full overflow-hidden my-[17px]'>
                {
                    trendData && (
                        trendData.map((data, idx) => (
                            <div className="relative" key={`trend-svg-wave-container-${idx}`}>
                                <SvgTrendWave 
                                    key={`trend-svg-wave-item-${idx}`}
                                    data={data}
                                    boxInfo={boxInfo}
                                    style={ moment(data[0].createdAt).isSame(moment(selectTime)) ? selectBoxStyle : defaultBoxStyle }                                        
                                    patientDischargeMarker={patientDischargeMarker}
                                />
                            </div>
                        ))
                    )
                }
            </div>
            <div className='flex w-full items-center justify-end'>
                 <span className={timeFontStyle}>{endTime ? moment(endTime).format('YYYY-MM-DD HH:mm:ss') : '---'}</span>
            </div>
        </div>      
    )
}

export default TrendWave